import { ISelectData } from 'components/atoms/SelectComponent';

import { EKvorumEnums } from 'enums/akcionarKorpAkce/kvorumEnums';

export const kvorumSelect: ISelectData[] = [
    {
        labelcz: 'SRD_PRUVODCE_VH_E_KVORUM_NE',
        value: EKvorumEnums.NE
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_E_KVORUM_POCET',
        value: EKvorumEnums.POCET
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_E_KVORUM_PROCENTA',
        value: EKvorumEnums.PROCENTA
    }
];
